import { IsIn, IsObject, IsOptional, IsString } from 'class-validator';

/**
 * Ad platform an HTML5 banner is built for. Drives the size, file-count and
 * animation budgets the publish-readiness checks hold the template to.
 * `generic` (the default when unset) only warns.
 */
export const HTML5_TARGET_PLATFORMS = ['generic', 'google_ads', 'dv360', 'cm360'] as const;
export type Html5TargetPlatform = (typeof HTML5_TARGET_PLATFORMS)[number];

export class HtmlConfigDto {
	@IsOptional()
	@IsString()
	htmlWrapper?: string;

	@IsOptional()
	@IsObject()
	clickTagOptions?: Record<string, string>;

	@IsOptional()
	@IsIn(HTML5_TARGET_PLATFORMS)
	targetPlatform?: Html5TargetPlatform;
}
